import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

const styles = ({ spacing }: Theme) =>
  createStyles({
    card: {
      width: 650,
    },
  })

export default makeStyles(styles)
